var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFloorPlaninline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.745,
    height: 90.92,
    viewBox: "0 0 99.745 90.92",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#626262;}.b{fill:#797979;}.c{fill:#e9e9e9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.989 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.337,16H20.015V54.709H14.53A14.731,14.731,0,0,0,16.593,83.99H99.337a2.266,2.266,0,0,0,2.266-2.266V18.266A2.266,2.266,0,0,0,99.337,16Z",
    transform: "translate(0.13 13.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.552,7.267V68.639H14.945a14.887,14.887,0,0,0-12.93,14.55V18.6a2.505,2.505,0,0,1,0-.725A14.954,14.954,0,0,1,17.054,5h1.182a2.292,2.292,0,0,1,2.317,2.266Z",
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.944 38.995)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.191,49.663H69.659a2.266,2.266,0,0,0,0,4.533v2.266H47v-20.4A2.266,2.266,0,0,0,44.729,33.8H40.2a2.266,2.266,0,0,0,0,4.533h2.266V56.462H19.8V38.332H31.131a2.266,2.266,0,0,0,0-4.533H19.8V31.533A2.266,2.266,0,1,0,19.8,27H15.266a2.266,2.266,0,0,0,0,4.533v27.2A2.266,2.266,0,0,0,17.533,61H71.925a2.266,2.266,0,0,0,2.266-2.266V54.2a2.266,2.266,0,1,0,0-4.533Z",
    transform: "translate(-13 -11.136)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.266,31.332H19.8a2.266,2.266,0,1,0,0-4.533V24.533H42.462V35.864a2.266,2.266,0,0,0,4.533,0V24.533H69.659v24.93a2.266,2.266,0,0,0,0,4.533h4.533a2.266,2.266,0,1,0,0-4.533v-27.2A2.266,2.266,0,0,0,71.925,20H17.533a2.266,2.266,0,0,0-2.266,2.266V26.8a2.266,2.266,0,1,0,0,4.533Z",
    transform: "translate(-13 -20)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFloorPlaninline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/floor-plan.inline.94a0fbb710bba803ca66b33a52b071a9.svg";